export const JOURNEY_LEG_RESET_STATE = 'JOURNEY_LEG_RESET_STATE';
export const JOURNEY_LEG_CURRENT_ITEM = 'JOURNEY_LEG_CURRENT_ITEM';

export const JOURNEY_LEG_REQUEST_LOADING = 'JOURNEY_LEG_REQUEST_LOADING';
export const JOURNEY_LEG_REQUEST_SUCCESS = 'JOURNEY_LEG_REQUEST_SUCCESS';
export const JOURNEY_LEG_REQUEST_FAILED = 'JOURNEY_LEG_REQUEST_FAILED';

export const JOURNEY_LEG_CURRENT_ACTION = 'JOURNEY_LEG_CURRENT_ACTION';
export const JOURNEY_LEG_RESET_ACTION = 'JOURNEY_LEG_RESET_ACTION';